import React from 'react';
import MainTitle,{Title2, Text1} from '../wrapText';

export default class About extends React.Component{
    render() {
        return(
            <>
            <MainTitle title='About'>
                Сайт создан на <b>React</b>. И что?
            </MainTitle>
            <div className='container'>
                <Title2 align='center'>Сайт сделан для портфолио</Title2>
                <Text1>
                    Я с реактом работаю уже около полугода, а на гитхабе своих проектов на нем не было.
                    Поэтому я поступил так: поискал всевозможные, бесплатные базы данных, в данном случае это TheCatAPi,
                    чтобы практиковаться с get и post запросами на сервер и асинхронными функциями.
                    Пусть сам сайт весьма небольшой, но можно придумать как впихнуть ту или иную технологию чтобы показать
                    что я умею с этим работать и как я это делаю.
                </Text1>
                <Text1>
                    Ну а какие технологии использовать это уже зависит от твоих знаний) По факту маст-хэв: ООП подход,
                    правильное использование жизненных циклов, работа со state и props, асинхронные функции, react-router,
                    react-redux. Следующими по значимости я бы назвал автоматические тесты. Ну а далее уже наверное моменты
                    сугубо субъективные, вроде выбора способа работы со стилями, TypeScript и прочее.
                </Text1>
                <Text1>
                    Если кто-то знает похожую базу данных про собак или других животных буду благодарен за наводку - vanger.char@gmail.com.
                    Конечно, можете писать мне и по любым другим вопросам, буду очень рад!
                </Text1>
            </div>
            </>
        )
    }
}